import { defineDomainTranslations } from './defineDomainTranslations';

export const PAID_TRIAL_TRANSLATIONS = defineDomainTranslations({
  en: {
    'paidTrial.cancel.confirm': 'Cancel trial',
    'paidTrial.cancel.description':
      'You’ll keep all premium features until {date}. Then your account moves to the Free plan, and you won’t be charged.',
    'paidTrial.cancel.keep': 'Keep trial',
    'paidTrial.cancel.title': 'Cancel your trial?',
    'paidTrial.canceledInfo':
      'Your trial ends on {date}. Then your account moves to the Free plan. To keep premium features, choose a plan.',
    'paidTrial.claimAlreadyClaimed':
      'This trial payment is already linked to another account. Sign in to that account to use it.',
    'paidTrial.claimEmailMismatch': 'To link your trial payment, sign up with the email you paid with.',
    'paidTrial.claimNotClaimable':
      'We couldn’t link this trial payment to a new account automatically. Please contact support.',
    'paidTrial.planFeatures.dubbing': 'Dubbing',
    'paidTrial.planFeatures.dubbingOnly': 'Dubbing only',
    'paidTrial.planFeatures.title': 'Choose a plan that meets your needs',
    'paidTrial.planLabel': 'Trial',
    'paidTrial.renews':
      'Your trial ends on {date}. Then you’ll be charged {price} per {interval} for the {plan} plan unless you cancel.',
    'paidTrial.upgradeOnly': 'During your trial, you can only switch to Creator or a higher plan.',
  },
  es: {
    'paidTrial.cancel.confirm': 'Cancelar prueba',
    'paidTrial.cancel.description':
      'Mantendrás todas las funciones premium hasta el {date}. Después, tu cuenta pasará al plan gratuito y no se te cobrará nada.',
    'paidTrial.cancel.keep': 'Seguir con la prueba',
    'paidTrial.cancel.title': '¿Cancelar tu prueba?',
    'paidTrial.canceledInfo':
      'Tu prueba termina el {date}. Después, tu cuenta pasará al plan gratuito. Para mantener las funciones premium, elige un plan.',
    'paidTrial.claimAlreadyClaimed':
      'Este pago de prueba ya está vinculado a otra cuenta. Inicia sesión en esa cuenta para usarlo.',
    'paidTrial.claimEmailMismatch':
      'Para vincular el pago de tu prueba, regístrate con el correo electrónico con el que pagaste.',
    'paidTrial.claimNotClaimable':
      'No pudimos vincular automáticamente este pago de prueba a una cuenta nueva. Contacta con soporte.',
    'paidTrial.planFeatures.dubbing': 'Doblaje',
    'paidTrial.planFeatures.dubbingOnly': 'Solo doblaje',
    'paidTrial.planFeatures.title': 'Elige el plan que mejor se adapte a tus necesidades',
    'paidTrial.planLabel': 'Prueba',
    'paidTrial.renews':
      'Tu prueba termina el {date}. Después, se te cobrarán {price} al {interval} por el plan {plan}, salvo que canceles.',
    'paidTrial.upgradeOnly': 'Durante la prueba solo puedes cambiar a Creator o a un plan superior.',
  },
  fr: {
    'paidTrial.cancel.confirm': 'Annuler l’essai',
    'paidTrial.cancel.description':
      'Vous conservez toutes les fonctionnalités premium jusqu’au {date}. Ensuite, votre compte passera à l’offre gratuite et aucun montant ne vous sera facturé.',
    'paidTrial.cancel.keep': 'Poursuivre l’essai',
    'paidTrial.cancel.title': 'Annuler votre essai ?',
    'paidTrial.canceledInfo':
      'Votre essai se termine le {date}. Ensuite, votre compte passera à l’offre gratuite. Pour conserver les fonctionnalités premium, choisissez un forfait.',
    'paidTrial.claimAlreadyClaimed':
      'Ce paiement d’essai est déjà associé à un autre compte. Connectez-vous à ce compte pour l’utiliser.',
    'paidTrial.claimEmailMismatch':
      'Pour associer le paiement de votre essai, inscrivez-vous avec l’adresse e-mail utilisée pour payer.',
    'paidTrial.claimNotClaimable':
      'Nous n’avons pas pu associer automatiquement ce paiement d’essai à un nouveau compte. Contactez l’assistance.',
    'paidTrial.planFeatures.dubbing': 'Doublage',
    'paidTrial.planFeatures.dubbingOnly': 'Doublage uniquement',
    'paidTrial.planFeatures.title': 'Choisissez le forfait adapté à vos besoins',
    'paidTrial.planLabel': 'Essai',
    'paidTrial.renews':
      'Votre essai se termine le {date}. Ensuite, un montant de {price} vous sera facturé par {interval} pour le forfait {plan}, sauf annulation.',
    'paidTrial.upgradeOnly':
      'Pendant l’essai, vous pouvez uniquement passer au forfait Creator ou à un forfait supérieur.',
  },
  it: {
    'paidTrial.cancel.confirm': 'Annulla la prova',
    'paidTrial.cancel.description':
      'Manterrai tutte le funzioni premium fino al {date}. Poi il tuo account passerà al piano gratuito e non ti verrà addebitato nulla.',
    'paidTrial.cancel.keep': 'Mantieni la prova',
    'paidTrial.cancel.title': 'Annullare la prova?',
    'paidTrial.canceledInfo':
      'La prova termina il {date}. Poi il tuo account passerà al piano gratuito. Per mantenere le funzioni premium, scegli un piano.',
    'paidTrial.claimAlreadyClaimed':
      'Questo pagamento della prova è già collegato a un altro account. Accedi a quell’account per usarlo.',
    'paidTrial.claimEmailMismatch':
      'Per collegare il pagamento della prova, registrati con l’email che hai usato per pagare.',
    'paidTrial.claimNotClaimable':
      'Non è stato possibile collegare automaticamente questo pagamento della prova a un nuovo account. Contatta l’assistenza.',
    'paidTrial.planFeatures.dubbing': 'Doppiaggio',
    'paidTrial.planFeatures.dubbingOnly': 'Solo doppiaggio',
    'paidTrial.planFeatures.title': 'Scegli il piano più adatto alle tue esigenze',
    'paidTrial.planLabel': 'Prova',
    'paidTrial.renews':
      'La prova termina il {date}. Poi ti verranno addebitati {price} al {interval} per il piano {plan}, salvo disdetta.',
    'paidTrial.upgradeOnly': 'Durante la prova puoi passare solo a Creator o a un piano superiore.',
  },
  pt: {
    'paidTrial.cancel.confirm': 'Cancelar teste',
    'paidTrial.cancel.description':
      'Você manterá todos os recursos premium até {date}. Depois, sua conta passará para o plano gratuito e não haverá cobrança.',
    'paidTrial.cancel.keep': 'Continuar com o teste',
    'paidTrial.cancel.title': 'Cancelar seu teste?',
    'paidTrial.canceledInfo':
      'Seu teste termina em {date}. Depois, sua conta passará para o plano gratuito. Para manter os recursos premium, escolha um plano.',
    'paidTrial.claimAlreadyClaimed':
      'Este pagamento do teste já está vinculado a outra conta. Entre nessa conta para usá-lo.',
    'paidTrial.claimEmailMismatch':
      'Para vincular o pagamento do seu teste, cadastre-se com o e-mail que você usou para pagar.',
    'paidTrial.claimNotClaimable':
      'Não foi possível vincular automaticamente este pagamento do teste a uma nova conta. Entre em contato com o suporte.',
    'paidTrial.planFeatures.dubbing': 'Dublagem',
    'paidTrial.planFeatures.dubbingOnly': 'Apenas dublagem',
    'paidTrial.planFeatures.title': 'Escolha o plano ideal para suas necessidades',
    'paidTrial.planLabel': 'Teste',
    'paidTrial.renews':
      'Seu teste termina em {date}. Depois, será feita uma cobrança de {price} por {interval} pelo plano {plan}, a menos que você cancele.',
    'paidTrial.upgradeOnly': 'Durante o teste, você só pode mudar para o Creator ou para um plano superior.',
  },
  ru: {
    'paidTrial.cancel.confirm': 'Отменить пробный период',
    'paidTrial.cancel.description':
      'Все премиум-функции будут доступны до {date}. Затем аккаунт перейдёт на бесплатный тариф, и списаний не будет.',
    'paidTrial.cancel.keep': 'Продолжить пробный период',
    'paidTrial.cancel.title': 'Отменить пробный период?',
    'paidTrial.canceledInfo':
      'Пробный период закончится {date}. Затем аккаунт перейдёт на бесплатный тариф. Чтобы сохранить премиум-функции, выберите тариф.',
    'paidTrial.claimAlreadyClaimed':
      'Этот платёж за пробный период уже привязан к другому аккаунту. Войдите в этот аккаунт, чтобы воспользоваться пробным периодом.',
    'paidTrial.claimEmailMismatch':
      'Чтобы привязать платёж за пробный период, зарегистрируйтесь, указав тот же адрес электронной почты, который использовали при оплате.',
    'paidTrial.claimNotClaimable':
      'Не удалось автоматически привязать этот платёж за пробный период к новому аккаунту. Обратитесь в поддержку.',
    'paidTrial.planFeatures.dubbing': 'Дубляж',
    'paidTrial.planFeatures.dubbingOnly': 'Только дубляж',
    'paidTrial.planFeatures.title': 'Выберите тариф под свои задачи',
    'paidTrial.planLabel': 'Пробный период',
    'paidTrial.renews':
      'Пробный период закончится {date}. Затем за тариф {plan} будет списываться {price} в {interval}, если вы не отмените подписку.',
    'paidTrial.upgradeOnly': 'Во время пробного периода можно перейти только на тариф Creator или выше.',
  },
});
